<div class="m-3 trials-list">
  <h2>Clinical Trial Opportunities - The current patient shows eligibility for the following clinical trials:</h2>
  <div class="row trials-list-header">
    <div class="col-7">Trial Title</div>
    <div class="col-2">Therapeutic Area</div>
    <div class="col-2">Phase</div>
  </div> 
  <div *ngIf="clinicalTrialSubjectData?.length" class="expander">
    <div appClinicalTrialsExpander *ngFor="let clinicalTrialSubject of clinicalTrialSubjectData; let i = index" class="card trial-card" [clinicalTrialSubject]="clinicalTrialSubject" [index]="i"></div>
  </div>
</div>
